/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { EventArgs, markType } from "igniteui-react-core";
/**
 * @hidden
 */
var ValueChangedEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ValueChangedEventArgs, _super);
    function ValueChangedEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._oldValue = new Date();
        _this._newValue = new Date();
        return _this;
    }
    Object.defineProperty(ValueChangedEventArgs.prototype, "oldValue", {
        get: function () {
            return this._oldValue;
        },
        set: function (a) {
            this._oldValue = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ValueChangedEventArgs.prototype, "newValue", {
        get: function () {
            return this._newValue;
        },
        set: function (a) {
            this._newValue = a;
        },
        enumerable: true,
        configurable: true
    });
    ValueChangedEventArgs.$t = markType(ValueChangedEventArgs, 'ValueChangedEventArgs', EventArgs.$);
    return ValueChangedEventArgs;
}(EventArgs));
export { ValueChangedEventArgs };
//# sourceMappingURL=ValueChangedEventArgs.js.map
